import { render } from "./underwritter-group.vue?vue&type=template&id=7d0f64db&lang=html"
import script from "./underwritter-group.vue?vue&type=script&lang=js"
export * from "./underwritter-group.vue?vue&type=script&lang=js"

import "./underwritter-group.vue?vue&type=style&index=0&id=7d0f64db&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__